import { httpsCallable } from "firebase/functions";
import { functions } from ".";
import { isObjectNotEmpty, isStringNotEmpty } from "../utils/objectUtils";

export const getSalesTax = async (state) => {
    if (isStringNotEmpty(state)) {
        const func = httpsCallable(functions, "getsalestax", { timeout: 6000000 });

        const res = await func({ state: state });

        // console.log(res.data);
        return res.data;
    }

    return null;
};

export const createCouponUse = async (coupon, userId, order) => {
    if (isObjectNotEmpty(coupon) && isStringNotEmpty(userId) && isObjectNotEmpty(order)) {
        const func = httpsCallable(functions, "createcouponuse", { timeout: 6000000 });

        const res = await func({ coupon: coupon, userId: userId, order: order });

        // console.log(res.data);
        return res.data;
    }

    return null;
};

export const createReferralCoupon = async (userId) => {
    if (isStringNotEmpty(userId)) {
        const func = httpsCallable(functions, "createreferralcoupon", { timeout: 6000000 });

        const res = await func({ userId: userId });

        // console.log(res.data);
        return res.data;
    }

    return null;
};

export const getReferralCount = async (userId) => {
    if (isStringNotEmpty(userId)) {
        const func = httpsCallable(functions, "getreferralcount", { timeout: 6000000 });

        const res = await func({ userId: userId });

        // console.log(res.data);
        return res.data;
    }

    return [];
};